module.exports = __webpack_public_path__ + "img/d20191223_2.446bf741.jpg";